// iter416 — Dashboard "Overview" section: headline KPIs + AI insights +
// monthly close-out preview + Smart Reconcile digest. Pure layout
// composition — children own their fetches and visibility rules. The
// `hasModule` predicate is passed in so the widget gating stays in one
// place (the parent's user/permission context).
import { DashboardSection } from './DashboardSection';
import { StatCardsGrid } from './StatCardsGrid';
import AIInsightsWidget from '@/components/AIInsightsWidget';
import { MonthlyCloseoutWidget } from './MonthlyCloseoutWidget';
import { SmartReconcileWidget } from './SmartReconcileWidget';

export function OverviewSection({
  statCards = [],
  todayVsYest,
  fmtAmt,
  hasModule = () => false,
}) {
  return (
    <DashboardSection title="Overview" testId="dash-section-overview">
      <StatCardsGrid statCards={statCards} todayVsYest={todayVsYest} fmtAmt={fmtAmt} />
      <AIInsightsWidget />
      {/* iter406 — Monthly close-out preview widget. Surfaces the
          cron's next-run summary so users can act before the 1st. */}
      {hasModule('accounting') && <MonthlyCloseoutWidget testidPrefix="dash-closeout" />}
      {/* iter411 — Smart Reconcile daily digest widget. Shows a live
          snapshot of bank-matching health (auto-resolved last 24h,
          pending PT advance suggestions, unassigned backlog) and lets
          the user force-run the digest cron. */}
      {hasModule('accounting') && <SmartReconcileWidget testidPrefix="dash-smart-recon" />}
    </DashboardSection>
  );
}

export default OverviewSection;
